webpackJsonp([183328146348521],{

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(13);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SlideUp = __webpack_require__(5);
	
	var _SlideUp2 = _interopRequireDefault(_SlideUp);
	
	var _Browser = __webpack_require__(7);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import FillBg from '../components/FillBg';
	
	//import Link from 'gatsby-link';
	var SlideUp00 = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e8irwbx0'
	})(); /* eslint max-len: 0 */
	
	var ErrorPage = function ErrorPage() {
	  if ((0, _Browser2.default)() === 'chrome') {
	    SlideUp00 = _SlideUp2.default;
	  }
	  if (typeof window !== 'undefined') {
	    if (window.parent.location === self.location) {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: '404 | ' + _website2.default.siteTitle }),
	        _react2.default.createElement(_Header2.default, { slim: true, title: ':' + '\xA0' + ':' + '\xA0' + '404' + '\xA0' + ':' + '\xA0' + ':' }),
	        _react2.default.createElement(
	          _Container2.default,
	          null,
	          _react2.default.createElement(
	            SlideUp00,
	            { delay: 320 },
	            _react2.default.createElement(
	              'div',
	              { style: { marginLeft: '4rem' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'ERROR 404 '
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'The page you are looking for cannot be found. Refresh & try again soon.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                'NOTE: if you are trying to reach a game the file most likely is there, but the host throttled and cut the connection. Please try again, ideally with a fast, wired connection.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                ' ',
	                'Browse',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://GitHub.com/Sondro', target: '_blank', rel: 'nofollow noopener noreferrer' },
	                  'GitHub.com/Sondro'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { role: 'img', 'aria-label': 'wink' },
	                  '\uD83D\uDE09'
	                )
	              ),
	              _react2.default.createElement('p', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                position: 'relative',
	                paddingBottom: '56.25%',
	                overflow: 'hidden',
	                width: '100%',
	                height: 'auto',
	                marginBottom: '2rem'
	              }
	            },
	            _react2.default.createElement('iframe', {
	              style: {
	                position: 'absolute',
	                top: '0',
	                left: '0',
	                width: '100%',
	                height: '100%'
	              },
	              title: 'Sondro Playlist',
	              width: '560',
	              height: '315',
	              src: ''
	              // src="https://www.youtube.com/embed/videoseries?list=
	              , frameBorder: '0',
	              allowFullScreen: true
	            })
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    } else {
	      // alert('app');
	      return _react2.default.createElement('div', null);
	    }
	  }
	  return _react2.default.createElement('div', null);
	};
	exports.default = ErrorPage;
	
	/*
	            Check the{' '}
	            <a href="../sitemap" target="_blank" rel="nofollow noopener noreferrer">
	              Sitemap
	            </a>{' '}
	            or browse{' '}
	*/

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-jsx-97c286764fa5976f1a79.js